function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import PictureComponent from "/components/core/picture/picture-component";
import Button from "segments/desktop/core-components/button/button";
import CloseIcon from "/static/svg/icons/close.svg";
import classnames from "classnames";
import { setCookie } from "services/cookies-service";
import { HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME } from "constants/cookies";
import { trackEvent } from "services/bigbrain-service";
import { TOP_BANNER_CLOSED_CLICK, BANNER_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { themes } from "segments/segments-service";
import Colors from "styles/colors";
import { REGULAR_BUTTON_TYPE, SECONDARY_BUTTON_TYPE, YOUTUBE_POPUP_LINK_TYPE } from "segments/desktop/core-components/button/button-consts";
import { SM } from "components/core/new-button/button-component";
import { StyledBanner } from "./banner.scss";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
const BANNER_EXPIRE_DAYS = 7;
const SIGNUP_BANNER_PLACEMENT = "top_with_background_banner";
const Banner = (props)=>{
    const { bannerText, bannerLinkData, bannerCta, bannerleftImage, bannerRightImage, withCloseIcon, theme, buttonConfig, isMobileOrTabletBrowser, isSecondaryMenuNeeded, placement, hideBannerWithBackground, stickImagesToText, extraData, bannerHeight, mobileBannerText, bannerIcon, bannerIconHeight } = props;
    const [hideBanner, setHideBanner] = useState(hideBannerWithBackground && withCloseIcon); // for now only banner that can be closed use the cookie
    const getThemes = ()=>{
        return _object_spread_props(_object_spread({}, themes), {
            "dodger-blue": {
                color: Colors.white,
                background: Colors["dodger-blue"]
            }
        });
    };
    const getThemeStyle = ()=>{
        return getThemes()[theme] || {};
    };
    const themeStyle = getThemeStyle();
    const onCloseBanner = ()=>{
        trackEvent(TOP_BANNER_CLOSED_CLICK);
        setCookie(HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME, true, {
            expires: BANNER_EXPIRE_DAYS
        });
        setHideBanner(true);
    };
    const onBannerLinkClicked = (link)=>{
        trackEvent(BANNER_LINK_CLICKED, {
            kind: link
        });
    };
    const getBannerButtonProps = ()=>{
        let buttonProps = {
            ctaText: bannerCta,
            placement: placement || SIGNUP_BANNER_PLACEMENT,
            buttonSpinnerColor: themeStyle.background,
            parentSegment: "Banner",
            useCtaText: true,
            extraData
        };
        if (isMobileOrTabletBrowser) {
            const MOBILE_NOT_ALLOWED_BUTTON_TYPES = [
                REGULAR_BUTTON_TYPE
            ];
            const buttonType = buttonConfig.buttonType;
            const buttonDisplayType = buttonConfig.buttonDisplayType;
            const extraButtonProps = {};
            if (MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonType)) {
                extraButtonProps.buttonType = SECONDARY_BUTTON_TYPE;
            }
            if (buttonConfig.buttonType === YOUTUBE_POPUP_LINK_TYPE && MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonDisplayType)) {
                extraButtonProps.buttonDisplayType = SECONDARY_BUTTON_TYPE;
            }
            buttonProps = _object_spread_props(_object_spread({}, buttonProps, extraButtonProps), {
                buttonSize: SM
            });
        }
        return buttonProps;
    };
    const getBannerText = ()=>{
        return /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
            className: "banner-text",
            text: mobileBannerText && isMobileOrTabletBrowser ? mobileBannerText : bannerText,
            style: bannerIcon ? {
                textAlign: "left"
            } : {}
        });
    };
    return /*#__PURE__*/ _jsxs(StyledBanner, {
        className: classnames("banner", {
            "hide-banner": hideBanner,
            "top-margin": isSecondaryMenuNeeded
        }),
        buttonTextColor: theme,
        style: bannerHeight ? _object_spread_props(_object_spread({}, themeStyle), {
            height: bannerHeight
        }) : themeStyle,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("banner-content", {
                    "with-sticky-images": stickImagesToText
                }),
                children: [
                    bannerleftImage && !isMobileOrTabletBrowser && /*#__PURE__*/ _jsx("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: bannerleftImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "banner-text-and-cta",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "banner-text-and-link",
                            style: bannerIcon ? {
                                display: "flex",
                                "flex-direction": "row"
                            } : {},
                            children: [
                                bannerIcon && /*#__PURE__*/ _jsx("div", {
                                    className: "banner-icon-wrapper",
                                    style: {
                                        height: bannerIconHeight
                                    },
                                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                                        src: bannerIcon
                                    })
                                }),
                                getBannerText(),
                                bannerLinkData && /*#__PURE__*/ _jsx("a", {
                                    className: "banner-link",
                                    href: bannerLinkData.src,
                                    style: {
                                        color: themeStyle.color
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: ()=>onBannerLinkClicked(bannerLinkData.src),
                                    children: bannerLinkData.text
                                }),
                                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ _jsx("div", {
                                    className: "banner-cta-wrapper",
                                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig, getBannerButtonProps()))
                                })
                            ]
                        })
                    }),
                    bannerRightImage && !isMobileOrTabletBrowser && /*#__PURE__*/ _jsx("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: bannerRightImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    })
                ]
            }),
            withCloseIcon && /*#__PURE__*/ _jsx("div", {
                className: "close-icon-wrapper",
                onClick: onCloseBanner,
                children: /*#__PURE__*/ _jsx(CloseIcon, {})
            })
        ]
    });
};
Banner.defaultProps = DefaultProps;
export default withGenericConfig(Banner);
